export const CardAspect = {
  RATIO_3_2: 'ratio-3-2',
  RATIO_4_3: 'ratio-4-3',
  RATIO_16_9: 'ratio-16-9',
  CIRCLE: 'circle',
} as const;
export type CardAspect = (typeof CardAspect)[keyof typeof CardAspect];

export const CardProgressState = {
  NOT_STARTED: 'not-started',
  IN_PROGRESS: 'in-progress',
  IN_REVIEW: 'in-review',
  COMPLETED: 'completed',
  FAILED: 'failed',
} as const;
export type CardProgressState =
  (typeof CardProgressState)[keyof typeof CardProgressState];

export type CardMetric = {
  label: string;
  value: string;
};
